module.exports = __webpack_public_path__ + "static/media/application.3adf1d19.svg";